import React from 'react';
import FilterDateTimeInput from '../../../../../../../common/components/Form/filterInputs/DateTimeInput';
import { toUTCFormat } from '../../../helper';
import { makeDateTimeHandler } from '../../../../../../../common/hooks/useForm';
import { TELEMETRY_TIME_FORMAT } from '../../../../../../../common/constants/telemetry';

function DateTimeInput({ name, label, date, onChange, disabled, offset }) {
  return (
    <FilterDateTimeInput
      disabled={disabled}
      name={name}
      label={`${label}:`}
      value={toUTCFormat(date, offset)}
      onChange={makeDateTimeHandler({ name, call: onChange, format: TELEMETRY_TIME_FORMAT })}
      fullWidth
      containerProps={{ className: 'filter filter-date' }}
    />
  );
}

export default DateTimeInput;
